<template>
    <select :class="className">
        <option v-if="placeholder"></option>
        <option v-for="option in options" v-bind:key="option.id" :selected="option.id == value" :value="option.id">
            {{option.text}}
        </option>
        <slot></slot>
    </select>
</template>

<script>
export default ({
    props: {
        value: String,
        options: Array,
        className: String,
        icon: String,
        placeholder: String,
    },
    data() {
        let iconName = this.icon ? 'has-icon has-icon-' + this.icon : '';

        return {
            select2options: {
                placeholder: this.placeholder,
                containerCssClass: iconName,
                width: '100%',
                minimumResultsForSearch: Infinity
            }
        }
    },
    mounted() {
        this.select2init()
    },
    methods: {
        select2init() {
            let that = this;
            $(this.$el)
                .select2(this.select2options)
                .trigger('change')
                .on('change', function () {
                    that.$emit('input', this.value)
                })
        }
    },
    watch: {
        value: function (value) {
            $(this.$el).val(value).trigger('change')
        },
        options: function (options) {
            if (this.value && ! options.map(val => val.id).includes(this.value)) {
                this.$emit('input', '')
            }
            $(this.$el).trigger('change')
        }
    },
    beforeUnmount() {
        $(this.$el).off().select2('destroy');
    }
})
</script>
